import { Reveal, Chapter, MaskedLine } from "@/components/Reveal";

export default function About() {
    return (
        <section className="relative border-t border-white/10 py-28 md:py-36" data-testid="about-section">
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <Chapter number="09" label="About HIGHTS" />
                        <h2 className="mt-10 font-display text-4xl font-black leading-[0.98] tracking-tighter text-white sm:text-5xl" data-testid="about-headline">
                            <MaskedLine delay={0.1}><span className="block">One objective:</span></MaskedLine>
                            <MaskedLine delay={0.25}><span className="block text-white/50">growth and efficiency.</span></MaskedLine>
                        </h2>
                        <Reveal delay={0.35}>
                            <div className="mt-10 max-w-xl space-y-6 text-base font-light leading-relaxed text-white/60">
                                <p>
                                    HIGHTS is not a website agency. It is a technology and business development partner —
                                    a single team that designs, builds, automates and continuously improves the entire
                                    digital side of your business.
                                </p>
                                <p className="text-white/80">
                                    We don't believe businesses should have to stitch together ten different companies
                                    to manage their digital presence.
                                </p>
                                <p>
                                    So HIGHTS brings development, AI, automation, optimisation and digital infrastructure
                                    together into one connected system — for the local business taking its first enquiries
                                    online, and for the established company ready to operate at another level.
                                </p>
                            </div>
                        </Reveal>
                        <Reveal delay={0.45}>
                            <div className="mt-12 grid max-w-xl grid-cols-3 gap-px border border-white/10 bg-white/10">
                                {[
                                    ["Any", "industry"],
                                    ["Any", "size"],
                                    ["One", "system"],
                                ].map(([a, b]) => (
                                    <div key={b} className="bg-base p-5 text-center">
                                        <p className="font-display text-xl font-black text-white">{a}</p>
                                        <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.25em] text-white/40">{b}</p>
                                    </div>
                                ))}
                            </div>
                        </Reveal>
                    </div>
                    <Reveal className="lg:col-span-6" y={40}>
                        <div className="relative">
                            <div className="relative aspect-[4/5] overflow-hidden lg:aspect-[3/4]">
                                <img
                                    src="/assets/img/devices.jpg"
                                    alt="A bespoke HIGHTS website across laptop, tablet and phone"
                                    className="h-full w-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                            </div>
                            <div className="absolute -bottom-6 -left-4 max-w-[260px] border border-white/15 bg-black/85 p-6 backdrop-blur-md md:-left-8">
                                <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-white/40">The standard</p>
                                <p className="mt-2 text-sm font-light leading-relaxed text-white/75">
                                    Everything we ship looks, loads and converts like a product launch — because it is one.
                                </p>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
